export default "__VITE_ASSET__CppykVRQ__"